// extracted by mini-css-extract-plugin
export default {"splitter":"KrUVQP3PmAlUDZ1cGUjQ","fab":"D2WSZjiiHbSYCgAyYLwB"};